export default {
  // navMallAdv: [],
  unread: 0,
  pop: 0
};



// WEBPACK FOOTER //
// ./src/store/state.js